import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';
import ISite from '../../../app/_interfaces/ISite';
import ICalendarNote from '../../../app/_interfaces/ICalendarNote';
import moment from 'moment';
import ICalendar from '../../../app/_interfaces/ICalendar';

@Injectable({
  providedIn: 'root',
})
export class CalendarNotesService {
  constructor(private http: HttpClient) {}
  create(customers_id: number, sites_id: number, note: ICalendarNote) {
    return this.http.post(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/sites/${sites_id}/notes`,
      { note }
    );
  }

  update(
    customers_id: number,
    sites_id: number,
    notes_id: number,
    note: ICalendarNote
  ) {
    return this.http.patch(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/sites/${sites_id}/notes/${notes_id}`,
      note
    );
  }

  remove(customers_id: number, sites_id: number, notes_id: number) {
    return this.http.delete(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/sites/${sites_id}/notes/${notes_id}`
    );
  }

  getByCalendar(
    customers_id: number,
    site: ISite,
    calendar: ICalendar,
    options?: { start?: string; end?: string }
  ) {
    return this.http.get<ICalendarNote[]>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/sites/${site.id}/calendars/${calendar.id}/notes`,
      {
        params: options,
      }
    );
  }

  get(customers_id: number, site: ISite, notes_id: number) {
    return this.http
      .get<ICalendarNote>(
        `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/sites/${site.id}/notes/${notes_id}`
      )
      .pipe(
        map((note) => {
          note.date = moment(note.date).toDate();
          if (note.start) {
            note.start = moment
              .utc(
                moment(note.date).format('DD-MM-YYYY ') + note.start,
                'DD-MM-YYYY HH:mm'
              )
              .toDate();
          }

          if (note.end) {
            note.end = moment
              .utc(
                moment(note.date).format('DD-MM-YYYY ') + note.end,
                'DD-MM-YYYY HH:mm'
              )
              .toDate();
          }

          return note;
        })
      );
  }
}
